export default __webpack_public_path__ + "static/media/Recurve Bow of Impossible Vines.ed4cdc12.jpg";